

import { Observable } from 'rxjs';



export interface PatientWallet {
    id?: any;
    tenantId: any;
    branchId: any;
    regId: any;
    withdrawal?: any;
    deposit?: any;
    narration: string;
    refType: string;
    transcationDate: Date;
    createdDate:Date;
    updatedDate?:Date;
    createdBy:number;
    updatedBy?:number;
    createdIP?:string;
    updatedIP?:string;
    receiptRefNum?:string;

}


export abstract class PatientWalletData {
    abstract getById(url: string): Observable<PatientWallet>;
    abstract list(url: string): Observable<any[]>;
    abstract create(url: string, data: any): Observable<any>;
    abstract update(url: string, data: any): Observable<any>;
    abstract delete(url: string): Observable<any>;
    abstract searchList(url: string,data:any): Observable<any>;
}
